import React from 'react';
export var InputLabels;
(function (InputLabels) {
  InputLabels["DAY"] = "Day";
  InputLabels["MONTH"] = "Month";
  InputLabels["YEAR"] = "Year";
})(InputLabels || (InputLabels = {}));
export var monthFieldOptions = [{
  uuid: '',
  value: '',
  child: /*#__PURE__*/React.createElement(React.Fragment, null)
}, {
  uuid: 'january',
  value: 'january',
  child: /*#__PURE__*/React.createElement(React.Fragment, null, "January")
}, {
  uuid: 'february',
  value: 'february',
  child: /*#__PURE__*/React.createElement(React.Fragment, null, "February")
}, {
  uuid: 'march',
  value: 'march',
  child: /*#__PURE__*/React.createElement(React.Fragment, null, "March")
}, {
  uuid: 'april',
  value: 'april',
  child: /*#__PURE__*/React.createElement(React.Fragment, null, "April")
}, {
  uuid: 'may',
  value: 'may',
  child: /*#__PURE__*/React.createElement(React.Fragment, null, "May")
}, {
  uuid: 'june',
  value: 'june',
  child: /*#__PURE__*/React.createElement(React.Fragment, null, "June")
}, {
  uuid: 'july',
  value: 'july',
  child: /*#__PURE__*/React.createElement(React.Fragment, null, "July")
}, {
  uuid: 'august',
  value: 'august',
  child: /*#__PURE__*/React.createElement(React.Fragment, null, "August")
}, {
  uuid: 'september',
  value: 'september',
  child: /*#__PURE__*/React.createElement(React.Fragment, null, "September")
}, {
  uuid: 'october',
  value: 'october',
  child: /*#__PURE__*/React.createElement(React.Fragment, null, "October")
}, {
  uuid: 'november',
  value: 'november',
  child: /*#__PURE__*/React.createElement(React.Fragment, null, "November")
}, {
  uuid: 'december',
  value: 'december',
  child: /*#__PURE__*/React.createElement(React.Fragment, null, "December")
}, {
  uuid: 'jan. & feb.',
  value: 'jan. & feb.',
  child: /*#__PURE__*/React.createElement(React.Fragment, null, "Jan. & Feb.")
}, {
  uuid: 'feb. & march',
  value: 'feb. & march',
  child: /*#__PURE__*/React.createElement(React.Fragment, null, "Feb. & March")
}, {
  uuid: 'march & april',
  value: 'march & april',
  child: /*#__PURE__*/React.createElement(React.Fragment, null, "March & April")
}, {
  uuid: 'april & may',
  value: 'april & may',
  child: /*#__PURE__*/React.createElement(React.Fragment, null, "April & May")
}, {
  uuid: 'may & june',
  value: 'may & june',
  child: /*#__PURE__*/React.createElement(React.Fragment, null, "May & June")
}, {
  uuid: 'june & july',
  value: 'june & july',
  child: /*#__PURE__*/React.createElement(React.Fragment, null, "June & July")
}, {
  uuid: 'july & aug.',
  value: 'july & aug.',
  child: /*#__PURE__*/React.createElement(React.Fragment, null, "July & Aug.")
}, {
  uuid: 'aug. & sept.',
  value: 'aug. & sept.',
  child: /*#__PURE__*/React.createElement(React.Fragment, null, "Aug. & Sept.")
}, {
  uuid: 'sept. & oct.',
  value: 'sept. & oct.',
  child: /*#__PURE__*/React.createElement(React.Fragment, null, "Sept. & Oct.")
}, {
  uuid: 'oct. & nov.',
  value: 'oct. & nov.',
  child: /*#__PURE__*/React.createElement(React.Fragment, null, "Oct. & Nov.")
}, {
  uuid: 'nov. & dec.',
  value: 'nov. & dec.',
  child: /*#__PURE__*/React.createElement(React.Fragment, null, "Nov. & Dec.")
}, {
  uuid: 'dec. & jan.',
  value: 'dec. & jan.',
  child: /*#__PURE__*/React.createElement(React.Fragment, null, "Dec. & Jan.")
}, {
  uuid: 'spring',
  value: 'spring',
  child: /*#__PURE__*/React.createElement(React.Fragment, null, "Spring")
}, {
  uuid: 'summer',
  value: 'summer',
  child: /*#__PURE__*/React.createElement(React.Fragment, null, "Summer")
}, {
  uuid: 'autumn',
  value: 'autumn',
  child: /*#__PURE__*/React.createElement(React.Fragment, null, "Autumn")
}, {
  uuid: 'fall',
  value: 'fall',
  child: /*#__PURE__*/React.createElement(React.Fragment, null, "Fall")
}, {
  uuid: 'winter',
  value: 'winter',
  child: /*#__PURE__*/React.createElement(React.Fragment, null, "Winter")
}];